export default __webpack_public_path__ + "assets/ico_booking_lock-12c5c6d9.svg";